import { create } from "zustand";
import { produce } from "immer";

import { TrackingFile } from "@/hooks/files";

export interface IStore {
  uploading: boolean;
  uploadSucceeded: boolean;
  uploadFailed: boolean;
  trackingFiles: TrackingFile[];

  actions: {
    handleFileUploadProgress: (trackingId: string, { loaded, total }: { loaded: number; total: number }) => void;
    handleFileUploadComplete: (trackingId: string) => void;
    handleFileUploadError: (trackingId: string, errorMessage: string) => void;
    setStore: (state: Partial<Omit<IStore, "actions">>) => void;
    clearStore: () => void;
  };
}

const initialState: Omit<IStore, "actions"> = {
  uploading: false,
  uploadSucceeded: false,
  uploadFailed: false,
  trackingFiles: [],
};

export const useUploadStore = create<IStore>((set, get) => ({
  ...initialState,

  actions: {
    handleFileUploadProgress: (trackingId, { loaded, total }) => {
      set(
        produce<IStore>((state) => {
          const matchingItem = state.trackingFiles.find((upload) => upload.trackingId === trackingId);
          if (matchingItem) matchingItem.progress = Math.floor((loaded * 100) / total);
        })
      );
    },
    handleFileUploadComplete: (trackingId) => {
      set((prev) => ({
        ...prev,
        trackingFiles: prev.trackingFiles.filter((file) => file.trackingId !== trackingId),
      }));
    },
    handleFileUploadError: (trackingId, errorMessage) => {
      set(
        produce<IStore>((state) => {
          const matchingItem = state.trackingFiles.find((upload) => upload.trackingId === trackingId);
          if (matchingItem) {
            matchingItem.failed = true;
            matchingItem.progress = 100;
            matchingItem.errorMessages = [...(matchingItem.errorMessages ?? []), errorMessage];
          }
        })
      );
    },

    setStore: (state) => {
      set({ ...get(), ...state });
    },
    clearStore: () => {
      set({ ...initialState });
    },
  },
}));
